import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaPlus, FaTimes, FaDownload, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import PageTemplate from '../../components/Common/PageTemplate';

const AnitkabirZiyareti2025 = () => {
  const images = [
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/1.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/2.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/3.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/4.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/5.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/6.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/7.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/8.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/9.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/10.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/11.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/12.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/13.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/14.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/15.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/16.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/17.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/18.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/19.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/20.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/21.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/22.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/23.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/24.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/25.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/26.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/27.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/28.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/29.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/30.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/31.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/32.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/33.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/34.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/35.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/36.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/37.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/38.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/39.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/40.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/41.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/42.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/43.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/44.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/45.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/46.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/47.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/48.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/49.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/50.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/51.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/52.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/53.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/54.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/55.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/56.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/57.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/58.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/59.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/60.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/61.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/62.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/63.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/64.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/65.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/66.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/67.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/68.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/69.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/70.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/71.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/72.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/73.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/74.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/75.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/76.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/77.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/78.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/79.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/80.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/81.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/82.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/83.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/84.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/85.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/86.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/87.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/88.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/89.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/90.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/91.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/92.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/93.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/94.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/95.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/96.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/97.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/98.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/99.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/100.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/101.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/102.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/103.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/104.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/105.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/106.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/107.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/108.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/109.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/110.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/111.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/112.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/113.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/114.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/115.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/116.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/117.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/118.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/119.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/120.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/121.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/122.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/123.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/124.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/125.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/126.JPG",
    "https://fs.hacettepe.edu.tr/fenyeni/dosyalar/2025mezuniyetanitkabir/127.JPG"
  ];

  const [visibleImages, setVisibleImages] = useState(4);
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const showMoreImages = () => {
    setVisibleImages(prevVisible => {
      const newVisible = prevVisible + 8;
      return newVisible >= images.length ? images.length : newVisible;
    });
  };

  const openModal = (imageSrc, index) => {
    setSelectedImage(imageSrc);
    setCurrentImageIndex(index);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'unset';
  };

  const nextImage = () => {
    const nextIndex = (currentImageIndex + 1) % images.length;
    setCurrentImageIndex(nextIndex);
    setSelectedImage(images[nextIndex]);
  };

  const prevImage = () => {
    const prevIndex = (currentImageIndex - 1 + images.length) % images.length;
    setCurrentImageIndex(prevIndex);
    setSelectedImage(images[prevIndex]);
  };

  const downloadImage = async (imageSrc, imageName) => {
    try {
      const response = await fetch(imageSrc);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = imageName || 'anitkabir-ziyareti.jpg';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error('Download failed:', error);
      // Fallback: open in new tab
      window.open(imageSrc, '_blank');
    }
  };

  // Keyboard navigation
  React.useEffect(() => {
    const handleKeyDown = (e) => {
      if (!selectedImage) return;
      
      if (e.key === 'Escape') {
        closeModal();
      } else if (e.key === 'ArrowRight') {
        nextImage();
      } else if (e.key === 'ArrowLeft') {
        prevImage();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [selectedImage, currentImageIndex]);

  return (
    <PageTemplate
      title="2024-2025 Akademik Yılı Fen Fakültesi Mezunları Anıtkabir Ziyareti"
      subtitle="Mezuniyet coşkusunu ve gururunu Ata'nın huzurunda yaşadık."
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white p-6 md:p-10 rounded-2xl shadow-lg -mt-16 relative z-10">
          <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed">
            <p className="mb-4 text-lg">
              Üniversitemiz Fen Fakültesi'nin 2024-2025 Akademik Yılı mezunları, mezuniyet coşkusunu ve gururunu Anıtkabir'de taçlandırdı. 25 Temmuz 2025 Cuma günü düzenlenen anlamlı ziyaret, fakültemizin geleneksel mezuniyet etkinliklerinin en önemli parçalarından birini oluşturdu.
            </p>
            <p className="mb-6 text-lg">
              Türkiye Cumhuriyeti'nin kurucusu Ulu Önder Gazi Mustafa Kemal Atatürk'e saygı ve minnetlerini sunmak amacıyla gerçekleştirilen bu özel ziyarete, fakültemizden yeni mezun olan öğrencilerimiz, değerli aileleri ve akademik personelimiz yoğun katılım gösterdi. Tören, mozoleye çelenk sunulmasıyla başladı, ardından saygı duruşu ve İstiklal Marşı'nın coşkuyla okunmasıyla devam etti.
            </p>
            <p className="text-lg">
              Bu anlamlı gün, mezunlarımızın meslek hayatlarına atacakları ilk adım öncesinde, Atatürk'ün ilke ve devrimlerine olan bağlılıklarını bir kez daha göstermelerine vesile oldu. Kamuoyuna saygıyla duyurulur.
            </p>
          </div>
        </div>

        <div className="mt-16">
          <h2 className="text-4xl font-extrabold text-center text-gray-800 mb-12 tracking-tight">Ziyaretten Kareler</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
            {images.slice(0, visibleImages).map((src, index) => (
              <div 
                key={index} 
                className="group relative w-full h-64 overflow-hidden rounded-xl shadow-lg transform transition-all duration-500 ease-in-out hover:shadow-2xl hover:!scale-105 cursor-pointer"
                onClick={() => openModal(src, index)}
              >
                <img
                  src={src}
                  alt={`Anıtkabir Ziyareti ${index + 1}`}
                  className="w-full h-full object-cover transition-transform duration-500 ease-in-out group-hover:scale-110"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-center justify-center pointer-events-none">
                  <div className="text-white text-center">
                    <div className="text-lg font-semibold">Büyük görmek için tıklayın</div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {visibleImages < images.length && (
            <div className="text-center mt-12">
              <button
                onClick={showMoreImages}
                className="inline-flex items-center px-8 py-4 border border-transparent text-lg font-semibold rounded-full shadow-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-all transform hover:scale-105"
              >
                <FaPlus className="mr-3 -ml-1 h-5 w-5" />
                Daha Fazlasını Gör
              </button>
            </div>
          )}
        </div>
        
        <div className="text-center mt-16">
            <Link 
              to="/haberler" 
              className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-transform transform hover:scale-105"
            >
              <FaArrowLeft className="mr-3 -ml-1 h-5 w-5" />
              Tüm Haberlere Geri Dön
            </Link>
        </div>

      </div>

      {/* Modal */}
      {selectedImage && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-90" onClick={closeModal}>
          <div className="relative max-w-7xl max-h-full" onClick={(e) => e.stopPropagation()}>
            {/* Close Button */}
            <button
              onClick={closeModal}
              className="absolute top-4 right-4 z-10 p-2 bg-black bg-opacity-50 hover:bg-opacity-70 text-white rounded-full transition-all duration-200"
            >
              <FaTimes size={20} />
            </button>

            {/* Download Button */}
            <button
              onClick={() => downloadImage(selectedImage, `anitkabir-ziyareti-${currentImageIndex + 1}.jpg`)}
              className="absolute top-4 left-4 z-10 p-2 bg-blue-600 hover:bg-blue-700 text-white rounded-full transition-all duration-200"
            >
              <FaDownload size={20} />
            </button>

            {/* Navigation Buttons */}
            <button
              onClick={prevImage}
              className="absolute left-4 top-1/2 transform -translate-y-1/2 p-3 bg-black bg-opacity-50 hover:bg-opacity-70 text-white rounded-full transition-all duration-200"
            >
              <FaChevronLeft size={24} />
            </button>
            
            <button
              onClick={nextImage}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 p-3 bg-black bg-opacity-50 hover:bg-opacity-70 text-white rounded-full transition-all duration-200"
            >
              <FaChevronRight size={24} />
            </button>

            {/* Image */}
            <img
              src={selectedImage}
              alt={`Anıtkabir Ziyareti ${currentImageIndex + 1}`}
              className="max-w-full max-h-full object-contain rounded-lg shadow-2xl"
            />

            {/* Image Counter */}
            <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-black bg-opacity-50 text-white px-4 py-2 rounded-full text-sm">
              {currentImageIndex + 1} / {images.length}
            </div>
          </div>
        </div>
      )}
    </PageTemplate>
  );
};

export default AnitkabirZiyareti2025;
